import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

const ConciergeCard = ({ conciergeCase }) => (
  <div className='concierge-card'>
    <div className='concierge-card__img'>
      <img
        className='concierge-card__img-i'
        src='/images/recommend.png'
        alt='VenueScanner’s free Concierge service'
      />
    </div>
    <h3 className='concierge-card__title'>
      {conciergeCase
        ? 'Want help organising your event?'
        : 'Get matched with the best venues'}
    </h3>
    <p className='concierge-card__copy'>
      {conciergeCase
        ? 'VenueScanner’s free Concierge service finds the best venues for you - all for free!'
        : 'Tell us about your event and we’ll find the best venues to host it'}
    </p>
    <Button
      fullWidth
      size='large'
      variant='contained'
      href='https://www.venuescanner.com/pages/venue-finder/venue-finder'>
      {conciergeCase ? 'Contact Concierge' : 'Find venues'}
    </Button>
  </div>
);

ConciergeCard.propTypes = {
  conciergeCase: PropTypes.bool,
};

export default ConciergeCard;
